import React from "react";
import PropTypes from "prop-types";
import fetchJsonp from "fetch-jsonp";
import { buildUrl, getEnv } from "shared/utils";
import AuthContext, { initialContextValue } from "./AuthContext";

const userStatusEndpoint = buildUrl(getEnv("AUTH_URL"), "users/status.json");

/* eslint-disable react/no-unused-state */
class AuthContextProvider extends React.Component {
  constructor(props) {
    super(props);

    let initialState = {
      user: {
        ...initialContextValue.user,
        ...(props.auth && props.auth.user),
      },
      isFetching: false,
    };

    if (typeof window !== "undefined" && window.GLOBAL_UI_INITIAL_PROPS) {
      const { auth: serverAuth } = window.GLOBAL_UI_INITIAL_PROPS;

      initialState = {
        ...initialState,
        user: {
          ...initialState.user,
          ...(serverAuth && serverAuth.user),
        },
      };
    }

    initialState.isUserSignedIn = !!initialState.user.id;

    this.state = initialState;
  }

  componentDidMount = async () => {
    this.willUnmount = false;

    const { user } = this.state;

    if (!user.id && typeof window !== "undefined") {
      this.setState({ isFetching: true });

      const response = await fetchJsonp(userStatusEndpoint);
      const payload = await response.json();

      if (!this.willUnmount) {
        this.setState({
          user: { ...user, ...payload },
          isFetching: false,
          isUserSignedIn: !!payload.id,
        });
      }
    }
  };

  componentWillUnmount() {
    this.willUnmount = true; // isMounted() is deprecated
  }

  render() {
    const { children } = this.props;

    return (
      <AuthContext.Provider value={this.state}>{children}</AuthContext.Provider>
    );
  }
  /* eslint-enable react/no-unused-state */
}

AuthContextProvider.propTypes = {
  auth: PropTypes.shape({
    user: PropTypes.shape({
      id: PropTypes.string,
      email: PropTypes.string,
      username: PropTypes.string,
      avatar: PropTypes.string,
      facebookUid: PropTypes.string,
      profileSlug: PropTypes.string,
      timestamp: PropTypes.string,
      variant: PropTypes.string,
    }),
  }),
  children: PropTypes.element.isRequired,
};

AuthContextProvider.defaultProps = {
  auth: {
    user: initialContextValue.user,
  },
};

export default AuthContextProvider;
